import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CreateKaizen } from '../models/Kaizen';
import { KaizenSource } from '../models/KaizenSource';
import { KaizenSourceService } from '../Services/KaizenSource.Services';

@Component({
    selector: 'app-yokoten',
    templateUrl: './yokoten.component.html',
    styleUrls: ['./yokoten.component.css'],
    standalone: false
})
export class YokotenComponent implements OnChanges {
  CreateKaizenYokoten: CreateKaizen = new CreateKaizen();
  @Input() CreateKaizen: CreateKaizen = new CreateKaizen();
  @Output() emitKaizenYokoten: EventEmitter<CreateKaizen> = new EventEmitter<CreateKaizen>();
  isYokotened: boolean = false;
  yokotenToOtherShops: boolean = false;
  isyokotenFromOtherShop: boolean = false;
  haveBpaksID: boolean = false;
  isApplicableForSpecificShop: boolean = false;
  isApplicableAccrossOtherShops: boolean = false;
  isYokoyenFromAnotherShopYesNo: string = 'No';
  haveBpaksIDYesNo: string = 'No';
  yokotenToOtherShopYesNo: string = 'No';
  applicableForSpecificShopYesNo: string = 'No';
  applicableAccrossOtherShopsYesNo: string = 'No';
  kaizenSources!: KaizenSource[];
  kaizenSourcesLoaded!: boolean;
  formYokoten!: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder, private KaizenSourceService: KaizenSourceService) {
    this.getKaizenSources();
    this.formYokoten = this.formBuilder.group({
      isYokoyenFromAnotherShop: [''],
      haveBpaksID: [''],
      yokotenToOtherShop: [''],
      applicableForSpecificShop: [''],
      applicableAccrossOtherShops: [''],
      kaizenSourceId: [null, Validators.required],
      kaizenSourceDescription: [''],
      additionalKaizenSourceDescription: [''],
      kaizenSourceIdentifier: ['', Validators.required],
      kaizenKeyWord1: [''],
      kaizenKeyWord2: [''],
      kaizenKeyWord3: [''],
      kaizenKeyWord4: [''],
      kaizenKeyWord5: [''],
    });
  }

  ngOnChanges(): void {
    this.waitForInputValue().then(() => {
      if(this.CreateKaizen.companyID != undefined){
      this.isYokotened = this.CreateKaizen.isYokoyenFromAnotherShop;
      this.isApplicableForSpecificShop = this.CreateKaizen.applicableToSpecificShops;
      this.isApplicableAccrossOtherShops = this.CreateKaizen.applicableToAllShops;
      this.applicableForSpecificShopYesNo = this.CreateKaizen.applicableToSpecificShops == true ? 'Yes' : 'No';
      this.applicableAccrossOtherShopsYesNo = this.CreateKaizen.applicableToAllShops == true ? 'Yes' : 'No';
      this.formYokoten.controls['isYokoyenFromAnotherShop'].setValue(this.CreateKaizen.isYokoyenFromAnotherShop);
      this.isYokoyenFromAnotherShopYesNo = this.CreateKaizen.isYokoyenFromAnotherShop == true ? 'Yes' : 'No';
      this.formYokoten.controls['haveBpaksID'].setValue(this.CreateKaizen.haveBpaksID);
      this.haveBpaksIDYesNo = this.CreateKaizen.haveBpaksID == true ? 'Yes' : 'No';
      this.haveBpaksID = this.CreateKaizen.haveBpaksID;
      this.formYokoten.controls['kaizenSourceId'].setValue(this.CreateKaizen.kaizenSourceID);
      this.formYokoten.controls['kaizenSourceIdentifier'].setValue(this.CreateKaizen.kaizenSourceIdentifier);
      this.formYokoten.controls['kaizenSourceDescription'].setValue(this.CreateKaizen.kaizenSourceDescription);
      this.formYokoten.controls['additionalKaizenSourceDescription'].setValue(this.CreateKaizen.additionalKaizenSourceDescription);
      this.formYokoten.controls['yokotenToOtherShop'].setValue(this.CreateKaizen.applicableForOtherShopOrPlants);
      if (this.CreateKaizen.applicableToSpecificShops == undefined) {
        this.isApplicableForSpecificShop = false;
        this.formYokoten.controls['applicableForSpecificShop'].setValue(false);
      }
      else {
        this.formYokoten.controls['applicableForSpecificShop'].setValue(this.CreateKaizen.applicableToSpecificShops);
      }
      if (this.CreateKaizen.applicableToAllShops == undefined) {
        this.isApplicableAccrossOtherShops = false;
        this.formYokoten.controls['applicableAccrossOtherShops'].setValue(false);
      }
      else {
        this.formYokoten.controls['applicableAccrossOtherShops'].setValue(this.CreateKaizen.applicableToAllShops);
      }
      var tags = this.CreateKaizen.kaizenTags?.split('|');
      this.formYokoten.controls['kaizenKeyWord1'].setValue(tags?.length > 0 ? tags[0] : '');
      this.formYokoten.controls['kaizenKeyWord2'].setValue(tags?.length > 1 ? tags[1] : '');
      this.formYokoten.controls['kaizenKeyWord3'].setValue(tags?.length > 2 ? tags[2] : '');
      this.formYokoten.controls['kaizenKeyWord4'].setValue(tags?.length > 3 ? tags[3] : '');
      this.formYokoten.controls['kaizenKeyWord5'].setValue(tags?.length > 4 ? tags[4] : '');
      this.isyokotenFromOtherShop = this.CreateKaizen.isYokoyenFromAnotherShop;

      this.yokotenToOtherShops = this.CreateKaizen.applicableForOtherShopOrPlants;
      this.CreateKaizenYokoten.isYokoyenFromAnotherShop = this.CreateKaizen.isYokoyenFromAnotherShop;
      this.CreateKaizenYokoten.haveBpaksID = this.CreateKaizen.haveBpaksID;
      this.CreateKaizenYokoten.kaizenSourceIdentifier = this.CreateKaizen.kaizenSourceIdentifier;
      this.CreateKaizenYokoten.kaizenSourceDescription = this.CreateKaizen.kaizenSourceDescription;
      this.CreateKaizenYokoten.additionalKaizenSourceDescription = this.CreateKaizen.additionalKaizenSourceDescription;
      this.CreateKaizenYokoten.applicableForOtherShopOrPlants = this.CreateKaizen.applicableForOtherShopOrPlants;
      this.CreateKaizenYokoten.applicableToSpecificShops = this.CreateKaizen.applicableToSpecificShops;
      this.CreateKaizenYokoten.applicableToAllShops = this.CreateKaizen.applicableToAllShops;
      if(this.CreateKaizen.kaizenTags)
      {
        this.CreateKaizenYokoten.kaizenTags = this.CreateKaizen.kaizenTags;
      }
      else
      {
        this.CreateKaizenYokoten.kaizenTags = '||||'
      }
      
      this.CreateKaizenYokoten.kaizenSourceID = this.CreateKaizen.kaizenSourceID;
      this.emitYokoten();
    }
    });
  }
  waitForInputValue(): Promise<any> {
    return new Promise((resolve) => {
      if (this.CreateKaizen) {
        resolve(this.CreateKaizen);
      }
    });
  }
  onYokotenFromOtherShopChange(e: any) {
    this.isyokotenFromOtherShop = e.target.checked;
    this.isYokoyenFromAnotherShopYesNo = this.isyokotenFromOtherShop ? 'Yes' : 'No';

    //reset the values for yokoten.  If you are going from no to yes there should no be any values set, but just in case clear them out
    this.isApplicableForSpecificShop = false;
    this.CreateKaizenYokoten.applicableToSpecificShops = false;
    this.isApplicableAccrossOtherShops = false;
    this.CreateKaizenYokoten.applicableToAllShops = false;
    this.yokotenToOtherShops = false;
    this.CreateKaizenYokoten.applicableForOtherShopOrPlants = false;
    this.CreateKaizenYokoten.kaizenSourceDescription = '';
    this.CreateKaizenYokoten.additionalKaizenSourceDescription = '';
    this.CreateKaizenYokoten.kaizenSourceIdentifier = '';
    this.CreateKaizenYokoten.kaizenSourceID = 0;
    this.CreateKaizenYokoten.haveBpaksID = false;

    this.formYokoten.controls['kaizenSourceId'].setValue(this.CreateKaizenYokoten.kaizenSourceID);
    this.formYokoten.controls['kaizenSourceIdentifier'].setValue(this.CreateKaizenYokoten.kaizenSourceIdentifier);
    this.formYokoten.controls['kaizenSourceDescription'].setValue(this.CreateKaizenYokoten.kaizenSourceDescription);
    this.formYokoten.controls['additionalKaizenSourceDescription'].setValue(this.CreateKaizenYokoten.additionalKaizenSourceDescription);


    this.CreateKaizenYokoten.isYokoyenFromAnotherShop = e.target.checked;
    this.emitYokoten();
  }

  haveBpaksIDChange(e: any) {
    this.haveBpaksID = e.target.checked;
    this.haveBpaksIDYesNo = this.haveBpaksID ? 'Yes' : 'No';
    this.CreateKaizenYokoten.haveBpaksID = e.target.checked;
    if(!this.haveBpaksID)
    {
      this.CreateKaizenYokoten.kaizenSourceIdentifier = '';
      this.formYokoten.controls['kaizenSourceIdentifier'].setValue(this.CreateKaizenYokoten.kaizenSourceIdentifier);
    }
    this.emitYokoten();
  }

  kaizenSourceIdentifierchanged(e: any) {
    this.CreateKaizenYokoten.kaizenSourceIdentifier = this.formYokoten.controls['kaizenSourceIdentifier'].value;
    this.emitYokoten();
  }
  kaizenSourceIdChanged(e: any) {
    this.CreateKaizenYokoten.kaizenSourceID = this.formYokoten.controls['kaizenSourceId'].value;
    this.emitYokoten();
  }
  kaizenSourceDescriptionChanged(e: any) {
    this.CreateKaizenYokoten.kaizenSourceDescription = this.formYokoten.controls['kaizenSourceDescription'].value;
    this.emitYokoten();
  }
  addKaizenSourceDesChanged(e: any) {
    this.CreateKaizenYokoten.additionalKaizenSourceDescription = this.formYokoten.controls['additionalKaizenSourceDescription'].value;
    this.emitYokoten();
  }
  kaizenKeyWordChanged(e: any) {
    this.CreateKaizenYokoten.kaizenTags = this.formYokoten.controls['kaizenKeyWord1'].value + '|' + this.formYokoten.controls['kaizenKeyWord2'].value + '|' + this.formYokoten.controls['kaizenKeyWord3'].value + '|' + this.formYokoten.controls['kaizenKeyWord4'].value + '|' + this.formYokoten.controls['kaizenKeyWord5'].value;
    this.emitYokoten();
  }
  applicableForSpecifiShopChange(e: any) {

    this.isApplicableForSpecificShop = e.target.checked;// applicableForSpecifiShop
    if (this.isApplicableForSpecificShop) {
      this.applicableForSpecificShopYesNo = 'Yes';
      this.applicableAccrossOtherShopsYesNo = 'No'
      this.CreateKaizenYokoten.applicableToSpecificShops = true;
      this.CreateKaizenYokoten.applicableToAllShops = false;
      this.isApplicableForSpecificShop = true;
      this.isApplicableAccrossOtherShops = false;
      this.formYokoten.controls['applicableForSpecificShop'].setValue(true);
      this.formYokoten.controls['applicableAccrossOtherShops'].setValue(false);
    }
    else {
      this.applicableForSpecificShopYesNo = 'No';
      this.CreateKaizenYokoten.applicableToSpecificShops = false;
      this.formYokoten.controls['applicableForSpecificShop'].setValue(false);
      this.isApplicableForSpecificShop = false;
    }
    this.emitYokoten();
  }

  applicableAccrossOtherShopschange(e: any) {
    this.isApplicableAccrossOtherShops = e.target.checked;
    if (this.isApplicableAccrossOtherShops) {
      this.applicableForSpecificShopYesNo = 'No';
      this.applicableAccrossOtherShopsYesNo = 'Yes'
      this.CreateKaizenYokoten.applicableToSpecificShops = false;
      this.CreateKaizenYokoten.applicableToAllShops = true;
      this.isApplicableForSpecificShop = false;
      this.isApplicableAccrossOtherShops = true;
      this.formYokoten.controls['applicableForSpecificShop'].setValue(false);
      this.formYokoten.controls['applicableAccrossOtherShops'].setValue(true);
    }
    else {
      this.applicableAccrossOtherShopsYesNo = 'No'
      this.CreateKaizenYokoten.applicableToAllShops = false;
      this.formYokoten.controls['applicableAccrossOtherShops'].setValue(false);
      this.isApplicableAccrossOtherShops = false;
    }
    this.emitYokoten();

  }
  yokotenedToOtherShopChange(e: any) {
    this.yokotenToOtherShops = e.target.checked;
    this.CreateKaizenYokoten.applicableForOtherShopOrPlants = e.target.checked;
    if(!this.CreateKaizenYokoten.applicableForOtherShopOrPlants)
    {
      this.isApplicableForSpecificShop = false;
      this.CreateKaizen.applicableToSpecificShops = false;
      this.isApplicableAccrossOtherShops = false;
      this.CreateKaizen.applicableToAllShops = false
    }
    this.yokotenToOtherShopYesNo = this.yokotenToOtherShops ? 'Yes' : 'No';
    this.emitYokoten();
  }
  getKaizenSources() {
    this.KaizenSourceService.getKaizenSources().subscribe((data) => {
      this.kaizenSources = data.data;
      this.kaizenSourcesLoaded = true;
    }, (error) => {
      console.error('Error fetching kaizen sources:', error);
      this.kaizenSourcesLoaded = true;
    });
  }
  

  emitYokoten() {
    this.emitKaizenYokoten.emit(this.CreateKaizenYokoten);
  }
}
